import { render, staticRenderFns } from "./StorePoliciesComponent.vue?vue&type=template&id=4fd0344c&"
import script from "./StorePoliciesComponent.vue?vue&type=script&lang=js&"
export * from "./StorePoliciesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports